import { timeMonth } from "d3";
import { AxisLabel, AxisTick } from "./utils";


type XAxisProps = {
    xScale: any,
    yPosition: number,
    tickFormattingFunction: (tickVal: number) => string,
    margins: { top: number, bottom: number, left: number, right: number }
}


export function TimeAxis({ xScale, yPosition, tickFormattingFunction, margins }: XAxisProps) {

    const x1 = xScale(xScale.ticks(timeMonth.every(1))[0]);
    const fullAxisWidth = xScale(xScale.ticks(timeMonth.every(1))[xScale.ticks(timeMonth.every(1)).length - 1]);


    return (
        <g transform={`translate(0, ${yPosition})`}>
            {xScale.ticks(timeMonth.every(1)).map((tickVal: any, idx: number) => {
                return (
                    <g className="tick" key={tickVal} transform={`translate(${xScale(tickVal)}, 0)`}>
                        <AxisLabel translation={{ x: 0, y: 20 }} rotation={-40} tickVal={tickVal} tickFormattingFunction={tickFormattingFunction} />
                        <AxisTick orientation="vertical" />

                        <line y1={-yPosition + margins.top} y2={8} x1={0} x2={0} stroke={'#C0C0BB'} />
                    </g>
                )
            })}

            <line x1={x1} x2={fullAxisWidth} stroke={'#C0C0BB'} y1={0} y2={0} />
        </g>
    )



}